
export const config ={
  "baseUrl" : "https://irgogps.com/",
    "token" : window.sessionStorage.getItem("token") || window.localStorage.getItem('token'),
    "role" : window.sessionStorage.getItem("role") || window.localStorage.getItem('role') || 'client'
};